import { validateUrls } from "api/types"

export const urls = validateUrls({
  list: () => "/pollux/v1/user-subscriptions/",
  createSetupIntent: () => "/pollux/v1/user-subscriptions/setup-intents/",
  updatePaymentMethod: () => "/pollux/v1/user-subscriptions/payment-methods/",
  changePlan: () => "/pollux/v1/user-subscriptions/plans/",
})
